module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/scal360/view-scal360-purchase-history/view-scal360-purchase-history.component.css
// module id = 985
// module chunks = 1